<div class="dialog-container">
  <div class="dialog-header">
    <div class="header-wrapper">
      <mat-icon>check_circle</mat-icon>
      <div>
        {{ "prolindung.reviewApplication.approveApplication" | translate }}
      </div>
    </div>
    <mat-icon class="icon-close" (click)="onClose()">close</mat-icon>
  </div>

  <mat-divider></mat-divider>

  <form [formGroup]="renewalFormGroup"> 
    <div [innerHTML]="'prolindung.reviewApplication.approveDesc' | translate"></div>

    <div class="approve-container">
      <div class="field-item">
        <div>{{ "common.insuranceRoadtaxRenewalApplicationAmt" | translate }}
        </div>
        <mat-form-field appearance="standard">
          <span matPrefix>RM&nbsp;</span>
          <input matInput 
            type="text" 
            formControlName="insuranceRoadtaxRenewalApplicationAmt" 
            autocomplete="off" 
            [value]="renewalFormGroup.get('insuranceRoadtaxRenewalApplicationAmt')?.value | number : '1.2-2'" />
        </mat-form-field>
      </div>

      <div class="field-item">
        <div>{{ "common.monthlyInstalmentAmt" | translate }}</div>
        <mat-form-field appearance="standard">
          <span matPrefix>RM&nbsp;</span>
          <input matInput type="text" 
            formControlName="monthlyInstalmentAmt" 
            autocomplete="off"
            [value]="renewalFormGroup.get('monthlyInstalmentAmt')?.value | number " />
        </mat-form-field>
      </div>

      <div class="field-item">
        <div [innerHTML]="'prolindung.reviewApplication.installmentMonth' | translate"></div>
        <mat-form-field appearance="fill">
          <mat-select formControlName="instalmentMonths">
            <mat-option *ngFor="let num of months" [value]="num">
              {{ num }} {{ "common.month" | translate }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <button mat-stroked-button type="button" class="approve-btn" (click)="onSubmit()">
      {{ "common.submit" | translate }}
    </button>
  </form>

</div>